const regex = /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[A-Z0-9-]+\.)+[A-Z]{2,6}$/gim;
// Pulled From O'Reilly Book
export function ValidateEmail(emailaddress) {
  console.log('Validate ', emailaddress);
  const testaddress = emailaddress.trim();

  const results = testaddress.match(regex);

  console.log('Validate ', testaddress, ' with results ', results);
  if (results && results.length > 0) {
    console.log('Validate ', testaddress, ' with results ', results);
    return true;
  }
  console.log('Validate ', testaddress, ' with results ', 'false');
  return false;
}
